module.exports = __webpack_public_path__ + "img/icon-email.3e6b76d6.svg";